// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerTimeTrackingPEPMRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.resellerCustomerQuoteValues.timeTrackingPEPM)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.ResellerTimeTrackingPEPMRow.Title')}
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.timeTrackingPEPM,
                  state.currencyObject,
               )}
            </div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.timeTrackingTotalPrice,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
